const GTM_ID = 'GTM-NSJ7BG22'

type DataLayerWindow = Window & { dataLayer?: unknown[] }

// Google Tag Manager — same snippet as the official <head> code, run once on page load.
export function installGoogleTagManager() {
  ;(function (w: DataLayerWindow, d: Document, s: string, l: 'dataLayer', i: string) {
    w[l] = w[l] || []
    w[l]!.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s) as HTMLScriptElement
    const dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f)
    } else {
      d.head.appendChild(j)
    }
  })(window, document, 'script', 'dataLayer', GTM_ID)

  // Equivalent of the <noscript> body tag, added at the top of <body>.
  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)
}
